{
 "_id": "data/names.json",
 "_about": "The satirical names inventory (docs/story/names.md is made from this by tools/make-names-doc.py). Every entry names a game element and the word the player sees. Status: 'pick' is the default, 'alt' an alternative, 'review' needs a check before shipping. The rejected words and why are at the bottom, so nobody re-proposes them.",
 "_rules": [
  "Satire targets systems and procedures, never people who suffered and never a real person, party, union or student wing.",
  "In play, satire. In the debrief, plain and fair: no slang on the reality card or the other side's statement.",
  "No word that mocks a caste, class, religion, region, gender or disability, however popular.",
  "Many players are 16 or 17: nothing crude, no drugs or tobacco.",
  "English UI first, Hindi beside it. Slang stays in the language it lives in: a Hindi meme is not translated, it is glossed.",
  "Run the copy lint on every word here. It bans violent vocabulary, including ख़त्म and 'crush', even in a harmless phrase: allow exact phrases, never loosen the word list."
 ],
 "groups": [
  {
   "id": "player",
   "title": "The player's body",
   "items": [
    {
     "element": "Stamina",
     "word": "Ghee",
     "hi": "घी",
     "states": {
      "full": "Ghee full",
      "low": "Ghee kam hai",
      "empty": "Ghee khatam"
     },
     "status": "pick",
     "meme": "\"Ghee khatam\": completely drained, broke or past it (Instagram reaction meme)",
     "note": "Empty means you can only walk until you get chai or water. Never a death or a faint. The copy lint (tools/lint-copy.mjs) bans ख़त्म, so 'घी ख़त्म' fails as written: allow the exact phrase in the lint, or show it in Latin script only."
    },
    {
     "element": "Stamina meter",
     "word": "Ghee meter",
     "hi": "घी मीटर",
     "status": "pick",
     "meme": "the ghee, read like a fuel gauge",
     "note": "The HUD meter, always on screen in play, with the jog's starting line marked on it. Under your feet only 'Ghee khatam' shows, once it is too low to start a jog."
    },
    {
     "element": "Stamina refill",
     "word": "Cutting chai",
     "hi": "कटिंग चाय",
     "status": "pick",
     "meme": "the half-glass of tea; refills ghee",
     "note": "Water and food refill it too."
    },
    {
     "element": "Jog / sprint",
     "word": "Streak safe",
     "hi": "स्ट्रीक सेफ",
     "status": "pick",
     "meme": "protesters joked about keeping their running-app streaks alive while running from lathis (Al Jazeera, Jul 2026)",
     "note": "No app name: brands stay out."
    },
    {
     "element": "Pre-round loadout",
     "word": "GRWM: protest edition",
     "hi": "GRWM: प्रोटेस्ट एडिशन",
     "status": "pick",
     "meme": "\"get ready with me\" and \"fit check\" posts of homemade protest gear (Al Jazeera)",
     "note": "Water, cap, goggles, mask, power bank. Never a weapon."
    },
    {
     "element": "Score for cool, helpful acts",
     "word": "Aura",
     "hi": "ऑरा",
     "states": {
      "gain": "+10 aura",
      "big": "Aura farming",
      "loss": "-aura"
     },
     "status": "pick",
     "meme": "Gen Z \"aura points\"",
     "note": "Earned for steadying a toli, escorting a medic, sharing water. Never for shoving."
    },
    {
     "element": "Detained (the timer)",
     "word": "Uthaa liya",
     "hi": "उठा लिया",
     "status": "pick",
     "meme": "\"they picked him up\": how detention is said",
     "note": "The timer screen: 'Free bus ride to the thana. Sightseeing included.' Never shown as violence."
    }
   ]
  },
  {
   "id": "crowd",
   "title": "The crowd",
   "items": [
    {
     "element": "The crowd's own name",
     "word": "Tilchatte",
     "hi": "तिलचट्टे",
     "status": "review",
     "meme": "\"cockroaches\": the reported remark the movement took as its name",
     "note": "Open decision in season-1.md. Hindi word only, no party name or logo."
    },
    {
     "element": "A toli (group of 5)",
     "word": "Toli",
     "hi": "टोली",
     "status": "pick",
     "meme": "already in the game",
     "note": "Keep."
    },
    {
     "element": "Toli nerve (hausla)",
     "word": "Hausla",
     "hi": "हौसला",
     "states": {
      "steady": "Hausla buland",
      "fraying": "Hil gaye",
      "leaving": "Ghar chalo"
     },
     "status": "pick",
     "meme": "plain Hindi; 'hil gaye' = shaken",
     "note": "Keep the existing name; the states are the new part."
    },
    {
     "element": "Crowd morale",
     "word": "Josh",
     "hi": "जोश",
     "states": {
      "high": "Josh high",
      "low": "Scene off"
     },
     "status": "pick",
     "meme": "everyday Hinglish; 'scene off' = the mood is gone",
     "note": "Avoid the film line \"How's the josh?\": it belongs to the army and reads as mocking soldiers."
    },
    {
     "element": "Density danger",
     "word": "Dhakka-mukki",
     "hi": "धक्का-मुक्की",
     "states": {
      "warn": "Local train mode",
      "danger": "Saans lene do"
     },
     "status": "pick",
     "meme": "the rush-hour local-train joke",
     "note": "Danger state is plain: 'let people breathe'. A crush is never a joke."
    },
    {
     "element": "People arriving because it's trending",
     "word": "FOMO wave",
     "hi": "FOMO वेव",
     "status": "pick",
     "meme": "Gen Z slang an MP used in Parliament to mock the protest (Navbharat, Jul 2026)",
     "note": "Attention above a threshold pulls new tolis in from the edges."
    },
    {
     "element": "Chant / noise action",
     "word": "Thali bajao",
     "hi": "थाली बजाओ",
     "status": "pick",
     "meme": "the movement asked supporters to bring plates and spoons (WION, Jun 2026)",
     "note": "Raises josh. No reference to who once asked for it: the action is enough."
    },
    {
     "element": "Improvised gear",
     "word": "Jugaad",
     "hi": "जुगाड़",
     "status": "pick",
     "meme": "the makeshift fix",
     "note": "Tarp shade, bottle cooler, cardboard sign."
    },
    {
     "element": "The loudspeaker garble subtitle",
     "word": "[vasteguna huiya]",
     "hi": "[वास्तेगुने हुईंया]",
     "status": "alt",
     "meme": "a nonsense meme phrase an MP quoted in Parliament (Navbharat)",
     "note": "For the police loudspeaker's wordless garble. Funny once; don't repeat it."
    }
   ]
  },
  {
   "id": "cast",
   "title": "The cast (roles, never real people)",
   "items": [
    {
     "element": "The player",
     "word": "Aspirant",
     "hi": "अस्पिरेंट",
     "status": "pick",
     "meme": "what every exam-prep student calls themselves",
     "note": "No name by default; the player can type one."
    },
    {
     "element": "Companions from the PG",
     "word": "PG wale",
     "hi": "पीजी वाले",
     "status": "pick",
     "meme": "everyday",
     "note": "Two of them in s1e1 already."
    },
    {
     "element": "The creator (POV episode)",
     "word": "Creator bhai / didi",
     "hi": "क्रिएटर भाई / दीदी",
     "status": "pick",
     "meme": "everyday",
     "note": "A composite of many creators; never one person's channel or videos."
    },
    {
     "element": "The constable (POV episode)",
     "word": "Constable sahab",
     "hi": "कांस्टेबल साहब",
     "status": "pick",
     "meme": "how a constable is addressed",
     "note": "A composite from the reporting; never an identifiable officer. Respectful by design: the satire is 'upar se order', not the man."
    },
    {
     "element": "The older aspirant who never left",
     "word": "Bhaiya",
     "hi": "भैया",
     "status": "pick",
     "meme": "aspirants who fail and stay in Mukherjee Nagar become 'the bhaiyas' (Marcellus)",
     "note": "A mentor NPC: knows the shortcuts, has seen two leaks."
    },
    {
     "element": "The Founder (runs it online)",
     "word": "Admin",
     "hi": "एडमिन",
     "status": "pick",
     "meme": "the WhatsApp group admin",
     "note": "Speaks only through the phone feed. Fictional; not a likeness."
    },
    {
     "element": "The Teacher (on the fast)",
     "word": "Masterji",
     "hi": "मास्टरजी",
     "status": "pick",
     "meme": "everyday",
     "note": "Invented: not a likeness of the real educator."
    },
    {
     "element": "The Minister (offstage)",
     "word": "Mantri ji",
     "hi": "मंत्री जी",
     "states": {
      "away": "Mantri ji: MIA",
      "gone": "Istifa"
     },
     "status": "pick",
     "meme": "'MIA' is the Gen Z slang an MP used in Parliament (Navbharat)",
     "note": "Never seen, never named. The office, not the man."
    },
    {
     "element": "Placard asking for the resignation",
     "word": "Kuchu-puchu please resign",
     "hi": "कुचु-पुचु प्लीज़ रिज़ाइन",
     "status": "pick",
     "meme": "the affectionate meme word an MP quoted in Parliament (Navbharat)",
     "note": "One of the placard texts."
    },
    {
     "element": "Marshal",
     "word": "Volunteer bhaiya / didi",
     "hi": "वॉलंटियर भैया / दीदी",
     "status": "pick",
     "meme": "everyday",
     "note": "Replaces 'Marshal' in story mode only."
    },
    {
     "element": "Medic",
     "word": "Doctor didi",
     "hi": "डॉक्टर दीदी",
     "status": "pick",
     "meme": "everyday",
     "note": "Blue plus mark, as the red lines require."
    },
    {
     "element": "Press",
     "word": "Camera wale",
     "hi": "कैमरा वाले",
     "status": "pick",
     "meme": "everyday",
     "note": ""
    },
    {
     "element": "The counter-group",
     "word": "Certified deshbhakts",
     "hi": "सर्टिफाइड देशभक्त",
     "status": "review",
     "meme": "the self-appointed patriot who hands out certificates",
     "note": "An archetype, never a real group, party or symbol. No saffron, no religious mark. Tone review before shipping."
    }
   ]
  },
  {
   "id": "system",
   "title": "The system (the satire's real target)",
   "items": [
    {
     "element": "Police pressure meter",
     "word": "Upar se order",
     "hi": "ऊपर से ऑर्डर",
     "status": "pick",
     "meme": "the bureaucrat's 'orders from above', the classic deflection",
     "note": "Rises with time and crowding. Nobody in the game ever says who 'upar' is."
    },
    {
     "element": "Police line",
     "word": "Khaki wall",
     "hi": "ख़ाकी दीवार",
     "status": "pick",
     "meme": "",
     "note": "Generic police only."
    },
    {
     "element": "The van with the camera mast",
     "word": "Nazar",
     "hi": "नज़र",
     "status": "pick",
     "meme": "already the mission name",
     "note": "Keep."
    },
    {
     "element": "Section 144 / 163",
     "word": "Paanch ka panga",
     "hi": "पाँच का पंगा",
     "status": "alt",
     "meme": "five people together is the trouble",
     "note": "The brand already says 144; this is the in-play nickname."
    },
    {
     "element": "Internet shutdown wave",
     "word": "Digital detox (sponsored)",
     "hi": "डिजिटल डिटॉक्स (प्रायोजित)",
     "status": "pick",
     "meme": "the wellness trend",
     "note": "Minimap and uploads go dark (the season plan's blackout)."
    },
    {
     "element": "Metro stations shut",
     "word": "Station band hai",
     "hi": "स्टेशन बंद है",
     "status": "pick",
     "meme": "",
     "note": "The PA disruption lines already carry it."
    },
    {
     "element": "Negative PR wave",
     "word": "Prime time",
     "hi": "प्राइम टाइम",
     "states": {
      "hit": "Breaking: videshi haath!",
      "headline": "Toolkit mil gaya"
     },
     "status": "pick",
     "meme": "TV anchors who called protesters 'anti-national' and 'foreign-funded' were spoofed (Al Jazeera)",
     "note": "Fictional channel, fictional anchor, no real logo or face. Attention turns hostile for a while."
    },
    {
     "element": "Rumour",
     "word": "WhatsApp University",
     "hi": "व्हाट्सऐप यूनिवर्सिटी",
     "status": "pick",
     "meme": "the forward that is never true",
     "note": "Already 'Forwarded many times' in s1e1; this names the source."
    },
    {
     "element": "Official claim that all is well",
     "word": "Delulu",
     "hi": "डेलुलु",
     "status": "alt",
     "meme": "Gen Z slang an MP used in Parliament (Navbharat)",
     "note": "In play only (an NPC's reaction). Never on the debrief card."
    },
    {
     "element": "The paper leak",
     "word": "Paper aaya kya?",
     "hi": "पेपर आया क्या?",
     "status": "pick",
     "meme": "the aspirant's question the night before every exam",
     "note": "The leak is an event, not a character."
    },
    {
     "element": "The testing agency",
     "word": "the Pariksha Board",
     "hi": "परीक्षा बोर्ड",
     "states": {
      "nickname": "Leak-kendra"
     },
     "status": "review",
     "meme": "",
     "note": "Fictional stand-in. No pun on the real agency's initials."
    },
    {
     "element": "The re-test",
     "word": "Paper ka sequel",
     "hi": "पेपर का सीक्वल",
     "status": "pick",
     "meme": "the season/sequel joke",
     "note": ""
    }
   ]
  },
  {
   "id": "outcomes",
   "title": "Grades and outcomes",
   "items": [
    {
     "element": "Best grade",
     "word": "Ek number",
     "hi": "एक नंबर",
     "status": "pick",
     "meme": "'top tier'",
     "note": ""
    },
    {
     "element": "Good grade",
     "word": "Sahi hai",
     "hi": "सही है",
     "status": "pick",
     "meme": "'cool, that works'",
     "note": ""
    },
    {
     "element": "Poor grade",
     "word": "Faaltu",
     "hi": "फ़ालतू",
     "status": "pick",
     "meme": "'useless, a waste'",
     "note": "Grades the run, never the player."
    },
    {
     "element": "Documenting evidence",
     "word": "Clocked",
     "hi": "क्लॉक्ड",
     "status": "pick",
     "meme": "Gen Z 'clocked it', which an MP used in Parliament (Navbharat)",
     "note": "The Document verb's success toast."
    },
    {
     "element": "Round lost",
     "word": "Scene khatam",
     "hi": "सीन ख़त्म",
     "status": "review",
     "meme": "everyday",
     "note": "Same lint catch as 'Ghee khatam': ख़त्म is banned, so allow the exact phrase or keep it in Latin script."
    },
    {
     "element": "The debrief",
     "word": "Asli kahani vs tumhara run",
     "hi": "असली कहानी vs तुम्हारा रन",
     "status": "pick",
     "meme": "",
     "note": "Plain words on the card itself: no slang."
    }
   ]
  }
 ],
 "rejected": [
  {
   "word": "chapri",
   "why": "mocks class and, by its history, caste"
  },
  {
   "word": "ghanta",
   "why": "crude; many players are minors"
  },
  {
   "word": "moye moye",
   "why": "criticised for mocking disabled people (Wikipedia)"
  },
  {
   "word": "godi media, bhakt, andhbhakt",
   "why": "partisan insults for real groups: they fail the fairness test the debrief depends on"
  },
  {
   "word": "any wordplay on a real leader's or party's name",
   "why": "red line: no real person or party"
  },
  {
   "word": "the PM's exam-advice programme's name",
   "why": "a real government programme: points at a real person"
  },
  {
   "word": "'How's the josh?'",
   "why": "a film line that belongs to the army; reads as mocking soldiers"
  },
  {
   "word": "app and game brand names (the running app, the endless-runner game)",
   "why": "trademarks; describe the joke instead"
  },
  {
   "word": "langar, bhandara",
   "why": "religious community kitchens: a religious marker needs review first. Use 'volunteers' khana'"
  },
  {
   "word": "sutta",
   "why": "tobacco, with minors playing"
  }
 ],
 "sources": {
  "Al Jazeera, 25 Jul 2026: protesters' memes": "https://www.aljazeera.com/news/2026/7/25/indias-youth-protesters-are-fighting-modi-with-irreverent-humour-and-memes",
  "Navbharat Live: Gen Z slang in Parliament": "https://navbharatlive.com/india/gen-z-trending-slang-in-parliament-amid-anti-paper-leak-bill-know-what-it-meaning-1895156.html",
  "WION, Jun 2026: thali and chamach": "https://www.wionews.com/india-news/cockroach-janta-party-heads-to-delhi-s-jantar-mantar-again-for-protest-dipke-asks-supporters-to-bring-thali-and-chamach-here-s-why-neet-leak-1781927757065/amp",
  "Marcellus: the bhaiyas of Mukherjee Nagar": "https://marcellus.in/story/long-read-some-upsc-aspirants-dont-quit-mukherjee-nagar-even-after-failing-they-become-the-bhaiyas/",
  "Kaiwa: Hindi Gen Z slang 2026": "https://trykaiwa.com/blog/hindi-gen-z-slang-phrases-2026",
  "Kaiwa: Hindi online reactions 2026": "https://trykaiwa.com/blog/hindi-online-text-reactions-2026",
  "Wikipedia: Moye moye": "https://en.wikipedia.org/wiki/Moye_moye"
 }
}
